import { Truck, Phone } from 'lucide-react'

import { formatPrice, TextLink } from '@/modules/Frontend/UiBlocks'

import { AddToCartSection } from './AddToCartSection'
import { PHONE_NUMBER, PHONE_HOURS } from '../../../lib/constants'
import { getShippingCost } from '../../../lib/pricing'
import { getProductViewConfig } from '../../../lib/productViewConfig'
import { useProductAttributes } from '../../../state'

const infoClasses = 'font-main-font text-sm xl:text-base text-text-color'

function ShippingCostLine() {
  const { shippingConfig } = getProductViewConfig()
  const { productAttributes, loading } = useProductAttributes()

  if (loading || !productAttributes) return null

  const { isFreeShipping, price } = getShippingCost(
    productAttributes.price_range?.minimum_price?.final_price?.value ?? 0,
    productAttributes.category_shipping_price?.value,
    shippingConfig
  )

  if (!isFreeShipping && price === null) return null

  return (
    <div className="flex flex-row items-center justify-center md:justify-start xl:justify-start pl-0 xl:pl-5">
      <Truck className="w-5 h-5 mr-2" />
      <span className={infoClasses}>
        Cost transport:{' '}
        {isFreeShipping ? (
          <span className="font-bold text-main-color">GRATUIT</span>
        ) : (
          formatPrice(price)
        )}
      </span>
    </div>
  )
}

function PhoneOrderLine() {
  return (
    <div className="flex flex-row items-start justify-center md:justify-start xl:justify-start pl-0 xl:pl-5 md:mb-5 xl:mb-5">
      <Phone className="w-5 h-5 mr-2" />
      <div className="flex flex-wrap items-center xl:gap-1 justify-center md:justify-start pb-3 space-x-1 w-[250px] md:w-full xl:w-full">
        <span className={infoClasses}>
          Comanda prin telefon:{' '}
          <TextLink href={`tel:${PHONE_NUMBER.replace(/\s/g, '')}`}>
            {PHONE_NUMBER}
          </TextLink>
        </span>
        <span className={infoClasses}>{PHONE_HOURS}</span>
      </div>
    </div>
  )
}

export function ShippingInfo() {
  return (
    <div className="bg-cards-bg px-5 pt-3 xl:bg-inherit xl:px-0 xl:pt-0">
      <div className="flex flex-row items-center justify-start gap-3">
        <AddToCartSection />
      </div>
      <ShippingCostLine />
      <PhoneOrderLine />
    </div>
  )
}
